export default __webpack_public_path__ + "static/polygon6-f16f2ca704f9e361b033217ce79fe511.png";